import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import {
	Icon,
	Url,
	TEXT_ALIGNMENT_OPTIONS,
	HERO_IMG_PLACEMENTS,
	HeroImagePlacements,
	TextAlignmentOptions,
} from '#const';
import { getIconUrl } from '#utils';

const CopyAndImage = dynamic(() => import('./CopyAndImage'));

export const defaultOptions = {
	textSide: HeroImagePlacements.LEFT,
	heading: '<h3>Copy and Image Section Heading</h3>',
	headingAlignment: TextAlignmentOptions.LEFT,
	headingSpan: false,
	copy: '<p>Key points:</p><ul><li>First important point to consider</li><li>Second item with more detail</li><li>Third bullet for the list</li><li>Fourth item here</li><li>Fifth point in the list</li><li>Sixth and final item</li></ul>',
	copyAlignment: TextAlignmentOptions.LEFT,
	listColumns: false,
	image: Url.PLACEHOLDER_IMAGE as string,
	mobileImage: true,
	color: '#F9FAFB',
	line: false,
} as const;

Builder.registerComponent(CopyAndImage, {
	name: 'CopyAndImage',
	inputs: [
		{
			name: 'textSide',
			friendlyName: 'Text Side',
			type: 'string',
			enum: [...HERO_IMG_PLACEMENTS],
			defaultValue: defaultOptions.textSide,
			helperText: 'Which side of the section will the text fall?',
		},
		{
			name: 'heading',
			friendlyName: 'Heading Text',
			required: true,
			type: 'richText',
			defaultValue: defaultOptions.heading,
		},
		{
			name: 'headingAlignment',
			friendlyName: 'Heading Alignment',
			type: 'string',
			enum: [...TEXT_ALIGNMENT_OPTIONS],
			defaultValue: defaultOptions.headingAlignment,
			helperText: 'Optional text alignment for the heading.',
		},
		{
			name: 'headingSpan',
			friendlyName: 'Full Width Heading?',
			type: 'boolean',
			defaultValue: defaultOptions.headingSpan,
			helperText: `Should the heading span between
			the text and image (true) or just span the width of the text (false)`,
		},
		{
			name: 'copy',
			friendlyName: 'Body Text',
			required: true,
			type: 'richText',
			defaultValue: defaultOptions.copy,
		},
		{
			name: 'copyAlignment',
			friendlyName: 'Text Alignment',
			type: 'string',
			enum: [...TEXT_ALIGNMENT_OPTIONS],
			defaultValue: defaultOptions.copyAlignment,
			helperText: 'Optional text alignment for the body text.',
		},
		{
			name: 'listColumns',
			friendlyName: 'List Columns',
			type: 'boolean',
			required: false,
			defaultValue: defaultOptions.listColumns,
			helperText: 'Should Ordered or Unordered Lists flow into two columns',
		},
		{
			name: 'image',
			required: false,
			friendlyName: 'Image',
			type: 'file',
			allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
			defaultValue: {
				src: defaultOptions.image,
				alt: '',
			},
		},
		{
			name: 'mobileImage',
			friendlyName: 'Mobile Image',
			type: 'boolean',
			defaultValue: defaultOptions.mobileImage,
			helperText: 'Should the Image appear on mobile?',
		},
		{
			name: 'color',
			friendlyName: 'Background Color',
			type: 'color',
			defaultValue: defaultOptions.color,
			helperText: 'Be sure to select a color light enough for the text to have contrast',
		},
		{
			name: 'line',
			friendlyName: 'Dividing Line',
			type: 'boolean',
			defaultValue: defaultOptions.line,
			helperText: `Include dividing line under the headline?
				Color of line is set by the page secondary accent color.`,
		},
	],
	canHaveChildren: true,
	defaultChildren: [
		{
			'@type': '@builder.io/sdk:Element',
			component: {
				name: 'Button',
				options: {
					copy: 'Whats My Claim Worth',
					arrow: false,
					color: 'rgba(17, 186, 0, 1)',
				},
			},
		},
	],
	childRequirements: {
		message: 'Child must be a Button.',
		query: { 'component.name': { $eq: 'Button' } },
	},
	image: getIconUrl(Icon.IMAGE_TEXT_SECTION),
});
